module.exports = __webpack_public_path__ + "static/media/4@1280w.9bc19563.jpg";